<template>
	<svg class="svg-icon" :style="styleObj" aria-hidden="true">
		<use :xlink:href="iconName"></use>
	</svg>
</template>

<script>
	export default {
		name: 'SvgIcon',
		props: {
			// 图标名称（不带 icon- 前缀）
			name: {
				type: String,
				required: true,
			},
			// 尺寸（px）
			size: {
				type: [String, Number],
				default: 16,
			},
			// 颜色
			color: {
				type: String,
				default: '',
			},
		},
		computed: {
			iconName() {
				return `#icon-${this.name}`;
			},
			styleObj() {
				return {
					width: this.size + 'px',
					height: this.size + 'px',
					color: this.color,
				};
			},
		},
	};
</script>

<style scoped lang="scss">
	.svg-icon {
		display: inline-block;
		fill: currentColor;
		vertical-align: middle;
	}
</style>
